<div
  class="hemro-vertical-navigation-item-wrapper"
  [class.hemro-vertical-navigation-item-has-subtitle]="!!item.subtitle"
  [ngClass]="item.classes?.wrapper">

  <div
    class="hemro-vertical-navigation-item"
        [ngClass]="{'hemro-vertical-navigation-item-active': active,
                    'hemro-vertical-navigation-item-disabled': item.disabled,
                    'hemro-vertical-navigation-item-active-forced': item.active}"
    [matTooltip]="item.tooltip || ''">

    <!-- Icon -->
    @if (item.icon) {
      <mat-icon
        class="hemro-vertical-navigation-item-icon"
        [ngClass]="item.classes?.icon"
      [svgIcon]="item.icon"></mat-icon>
    }

    <!-- Title & Subtitle -->
    <div class="hemro-vertical-navigation-item-title-wrapper">
      <div class="hemro-vertical-navigation-item-title">
        <span [ngClass]="item.classes?.title">
          {{item.title | transloco}}
        </span>
      </div>
      @if (item.subtitle) {
        <div class="hemro-vertical-navigation-item-subtitle">
          <span [ngClass]="item.classes?.subtitle">
            {{item.subtitle | transloco}}
          </span>
        </div>
      }
    </div>

    <!-- Badge -->
    @if (item.badge) {
      <div class="hemro-vertical-navigation-item-badge">
        <div
          class="hemro-vertical-navigation-item-badge-content"
          [ngClass]="item.badge.classes">
          {{item.badge.title}}
        </div>
      </div>
    }

  </div>

</div>

@if (!skipChildren) {
  <div class="hemro-vertical-navigation-item-children">
    @for (item of item.children; track trackByFn($index, item)) {
      <!-- Skip the hidden items -->
      @if ((item.hidden && !item.hidden(item)) || !item.hidden) {
        <!-- Basic -->
        @if (item.type === 'basic') {
          <hemro-vertical-navigation-basic-item
            [item]="item"
          [name]="name"></hemro-vertical-navigation-basic-item>
        }
        <!-- Collapsable -->
        @if (item.type === 'collapsable') {
          <hemro-vertical-navigation-collapsable-item
            [item]="item"
            [name]="name"
          [autoCollapse]="autoCollapse"></hemro-vertical-navigation-collapsable-item>
        }
        <!-- Divider -->
        @if (item.type === 'divider') {
          <hemro-vertical-navigation-divider-item
            [item]="item"
          [name]="name"></hemro-vertical-navigation-divider-item>
        }
        <!-- Group -->
        @if (item.type === 'group') {
          <hemro-vertical-navigation-group-item
            [item]="item"
          [name]="name"></hemro-vertical-navigation-group-item>
        }
        <!-- Spacer -->
        @if (item.type === 'spacer') {
          <hemro-vertical-navigation-spacer-item
            [item]="item"
          [name]="name"></hemro-vertical-navigation-spacer-item>
        }
      }
    }
  </div>
}
